
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { ComputerService } from './computer.service';
import ComputerInterface from '@/interfaces/Computer.interface';
import { LicenseService } from '../Licenses/license.service';
import { ToastFactory } from '@/utils/ToastFactory';
import useVuelidate from '@vuelidate/core';
import { required, numeric } from '@vuelidate/validators';
import AutoComplete from 'primevue/autocomplete';
const computerService = new ComputerService();
const licenseService = new LicenseService();

export default defineComponent({
    name: "AddComputer",
    data() {
        return {
            form: {
                computer: {
                    active: true,
                    licenseId: "" as string,
                    license: {
                        id: "" as string,
                    } as any,
                } as any,
            },
            pickedLicense: '' as any,
            edit: false,
            computerId: "" as string,
            licenses: [] as any,
            params: {
                name: '',
                active: true,
                page: 0,
                size: 100
            }
        };
    },
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    validations() {
        if (!this.computerId) {
            return {
                form: {
                    computer: {
                        name: {
                            required: required
                        },
                        userComputer: {
                            required: required
                        },
                        password: {
                            required: required
                        },
                        anydeskId: {
                            required: required
                        },
                        passwordAnydesk: {
                            required: required
                        },
                        active: {
                            required: required
                        },
                        licenseId: {
                            required: required
                        },
                    }
                }
            };
        }
        else {
            return {
                form: {
                    computer: {
                        name: {
                            required: required
                        },
                        userComputer: {
                            required: required
                        },
                        password: {
                            required: required
                        },
                        anydeskId: {
                            required: required
                        },
                        passwordAnydesk: {
                            required: required
                        },
                        active: {
                            required: required
                        },
                        license: {
                            id: {
                                required: required
                            }
                        }
                    }
                }
            };
        }
    },

    computed: {
        ...mapGetters({
            storeComputer: "computers/getComputer",
            storeLicenses: "licenses/getLicenses",
            licenseComputer: "licenses/getLicense"
        }),
    },
    methods: {
        async getComputerById() {
            computerService.getComputerById(this.computerId).then(() => {
                this.form.computer = this.storeComputer;
                this.getLicenseId();
            });
        },

        getLicenseId() {
            licenseService.getLicenseById(this.form.computer.license.id).then(() => {
                this.pickedLicense = this.licenseComputer;
            });
        },

        getLicenses(event: any) {
            this.params.name = event.query;
            licenseService.getLicenses(this.params).then(() => {
                this.licenses = this.storeLicenses.content.map((license: any) => {
                    return {
                        id: license.id,
                        licenseId: license.licenseId
                    };
                });
            });
        },

        addNewComputer(data: ComputerInterface): void {
            computerService.addComputer(data)
                .then(() => {
                this.$router.push({ name: "Computers" });
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessEquip")));
            }).catch((e) => {
                console.log("error", e);
                this.$toast.add(ToastFactory.error(this.$t("toast.errorEquip")));
            });
        },

        updateComputer(data: ComputerInterface): void {
            computerService.updateComputer(this.computerId, data)
                .then(() => {
                this.$router.push({ name: "Computers" });
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessEquipEdit")));
            }).catch((e) => {
                console.log("error", e);
                this.$toast.add(ToastFactory.error(this.$t("toast.errorEquipEdit")));
            });
        },
        sendComputer(): void {
            this.form.computer.licenseId = this.pickedLicense.id;
            console.log(JSON.stringify(this.form.computer));
            this.v$.form.$touch();
            if (!this.v$.form.$error) {
                this.computerId ? this.updateComputer(this.form.computer) : this.addNewComputer(this.form.computer);
            }
        }
    },
    mounted() {
        this.computerId = this.$route?.params?.id as string;
        this.computerId ? this.getComputerById()  : null;
    },
});
